// DS1.13
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import s from './Loader.scss';

interface Props {
  size: 'big' | 'small';
  state?:
    | 'loading'
    | 'laying_eggs'
    | 'static'
    | 'static_color'
    | 'popcorn'
    | 'eating'
    | 'eating_grass'
    | 'spitting'
    | 'skeleton'
    | 'valentines'
    | 'holiday'
    | 'balloons'
    | 'disabled';
  className?: string;
}

const Loader: React.FC<Props> = ({ size, state = 'loading', className }) => {
  const getImagePath = state =>
    ({
      loading: 'loading/llama-med.gif',
      laying_eggs: 'loading/llama-egg.gif',
      static: 'loading/llama-static.png?2',
      static_color: 'loading/llama-static.gif?2',
      disabled: 'loading/llama-disabled.png',
      popcorn: 'loading/llama-popcorn.gif',
      eating: 'loading/llama-eating.gif',
      eating_grass: 'loading/llama-eating-grass.gif?1',
      spitting: 'loading/llama-spitting.gif',
      skeleton: 'loading/llama-skeleton.gif',
      valentines: 'loading/llama-love.gif',
      balloons: 'loading/llama-with-balloons-grad.gif',
      holiday: 'loading/llama-prancing.gif',
      pride: 'loading/llama-pride22.gif',
    })[state];

  return (
    <div className={classnames(s['root'], s[size], s[state], className)}>
      <img
        src={Url.staticCDNLink(getImagePath(state))}
        alt=""
        className={s['llama']}
      />
    </div>
  );
};
Loader.displayName = 'Loader';

export default Loader;
